export default ({ Descripcion, SubTitulo, TextoFooter, Titulo, Metadata }) => ({
    description: Descripcion,
    subtitle: SubTitulo,
    footerText: TextoFooter,
    title: Titulo,
    metadata: Metadata
})